import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTop from "@/components/base/ScrollToTop";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <Navbar />
        <main className="min-h-screen pt-16">
          <AppRoutes />
        </main>
        <Footer />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;